import { render, staticRenderFns } from "./discountApproveStatusBadge.vue?vue&type=template&id=a55fc2f8&"
import script from "./discountApproveStatusBadge.vue?vue&type=script&lang=js&"
export * from "./discountApproveStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports